import { AfterViewInit, Component, OnChanges, OnDestroy, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { componentDestroyed } from '@w11k/ngx-componentdestroyed';
import { takeUntil } from 'rxjs/operators';
import { AssigTripsService } from 'src/app/service/assigntrips-service/assigntrips-service';
import { SocketService } from 'src/app/service/socket-service/socket-service.service';
import { Events } from 'src/app/utils/event-utils';
import * as moment from 'moment-timezone';
import { SharedDataService } from 'src/app/service/shared-service/shared-data.service';
import { sweetAlert } from 'src/app/utils/swal';
import { AnnouncerService } from 'src/app/service/announcement-service/announcer.service';
import { LocalStorageService } from 'src/app/service/local-storage-service/local-storage-service.service';
import { LevelOfServiceService } from 'src/app/service/level-of-service/level-of-service.service';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from 'src/app/service/auth-service/auth.service';
import { TokenInterceptorService } from 'src/app/service/token-interceptor-service/token-interceptor.service';
import { PublicOperationsServiceService } from '../public-operations-service/public-operations.service';

@Component({
  selector: 'app-public-operations',
  templateUrl: './public-operations.component.html',
  styleUrls: ['./public-operations.component.css']
})
export class PublicOperationsComponent implements OnInit {
  @ViewChild('timer', { static: true }) timer: any;
  skip = 0;
  isMute = false;
  language = "en-US";
  trips: any = [];
  dataLoaded = true;
  selectedTripId: any
  todayDate
  timeZone: any;
  user: any;
  duration = 20 * 1000; // 10 seconds
  isSound = true;
  showStatusPopup = false;
  legMapper = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'];
  spaceTypeList: any;
  preSpaceTypes = {};

  constructor(
    private socketService: SocketService,
    private assignTripService: AssigTripsService,
    private announcer: AnnouncerService,
    private localStorageService: LocalStorageService,
    private operationService: PublicOperationsServiceService,
    private router: Router,
  ) {

  }

  ngOnInit() {
    this.getUser();



    this.localStorageService.observeItem<string>('speaking-language').subscribe((lng) => {
      this.language = lng ? lng : "en-US";
    });

    this.localStorageService.observeItem<string>('speaking-sound').subscribe((status) => {
      this.isMute = status !== null ? JSON.parse(status) : true;
    });

    window.addEventListener('storage', this.storageListener);

    if (localStorage.getItem("sound")) {
      this.isSound = JSON.parse(localStorage.getItem("sound"));
    }
  }
  onTimerComplete(): void {
    this.timer.init()
    this.getTrips();

  }
  ngAfterViewInit(): void {
    this.timer.start();
  }

  storageListener = (event) => {
    if (event.key === 'sound') {
      if (event.newValue) {
        this.isSound = JSON.parse(event.newValue);
      }
    }
  }

  getUser() {
    this.operationService.VerifyTokenModified().pipe(takeUntil(componentDestroyed(this)))
      .subscribe((data) => {
        if (data && data.user) {
          this.user = data.user;
          this.operationService.saveUser(data.user);
          this.getTrips();
          this.getSpaceTypes();
          this.timeZone = this.user.company.timeZone;
          this.todayDate = moment().tz(this.timeZone).format('YYYY-MM-DD');
        } else {
          sweetAlert("Error", "Invalid Token", "error", "Ok");
        }
      }, (err) => {
        sweetAlert("Error", err, "error", "Ok");
      });
  }


  getTrips() {
    this.operationService
      .getOperationTripsByToken()
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(
        (data) => {
          if (data) {
            this.timer.start();
            if (!this.dataLoaded) {
              this.compareTrips(this.trips, data);
            }
            this.trips = data
            this.sortTrips();
            this.dataLoaded = false;
          }
        });
  }

  formatDate(time) {
    return moment(time).tz(this.timeZone).format('HHmm');
  }

  compareTrips(previous: any[], current: any[]) {
    const changes = current.filter((newTrip) => {
      const oldTrip = previous.find((t) => t._id === newTrip._id);
      return ['onway', 'arrived'].includes(newTrip.jobStatus) && (!oldTrip || oldTrip.jobStatus !== newTrip.jobStatus);
    });

    if (changes.length) {
      changes.forEach(trip => {
        this.announceTrip(trip)
      });
    }
  }



  sortTrips() {
    const statusOrder = { "arrived": 1, "onway": 2, "offered": 3, "accepted": 4 };
    this.trips.sort((a, b) => {
      let statusA = statusOrder[a.jobStatus] || 999; // Default to high number for unknown statuses
      let statusB = statusOrder[b.jobStatus] || 999;

      if (statusA !== statusB) {
        return statusA - statusB; // Sort by status order
      }

      return moment(a.scheduleTime).valueOf() - moment(b.scheduleTime).valueOf(); // If same status, sort by time
    });

    for (let item of this.trips) {
      if (item.jobStatus === 'onway') {
        this.calculateMiles(item);
      }
    }
  }

  loadedMiles(trip) {
    this.selectedTripId = trip._id;
    const payload = {
      assignId: trip._id,
      isDriveTime: true,
    };
    this.socketService.emit(Events.GET_ASSIGN_TRIP_ETA, payload);
  }


  calculateMiles(trip) {
    const queryParams = {
      start: [trip.driver.longitude, trip.driver.latitude].toString(),
      end: [trip.jobOriginLongitude, trip.jobOriginLatitude].toString(),
    };

    this.assignTripService.calculateMiles(queryParams).subscribe((data: any) => {
      if (data) {
        let duration = 0;

        if (
          data &&
          data.features &&
          data.features[0] &&
          data.features[0].properties &&
          data.features[0].properties.segments &&
          data.features[0].properties.segments[0] &&
          data.features[0].properties.segments[0].duration
        ) {
          duration = data.features[0].properties.segments[0].duration;
        }

        trip.etaTime = this.formatDuration(duration);
      }
    }, (err) => {
      // sweetAlert("Error", 'Invalid Address', "error", "Ok");
    })
  }

  formatDuration(durationValue: any) {
    // Convert the duration into a moment duration object
    let duration = moment.duration(durationValue, 'seconds');
    // Extract hours and minutes from the duration
    let hours = Math.floor(duration.asHours());  // Get the integer value of hours
    let minutes = duration.minutes();  // Get the remaining minutes
    // Return the result based on the hours
    if (hours > 0) {
      return `${hours} Hr ${minutes} Mins`;
    } else {
      return `${minutes} Mins`;
    }
  }

  formatDistance(distance: any) {
    return `${Number((distance / 1609.344).toFixed(2))} mi`;
  }

  getStatusMessage(status) {
    switch (status) {
      case "pending":
      case "offered":
      case "accepted":
        return "Contact trip coordinator for the ride activation";
      case "onway":
        return "Driver is on the way, Please stay ready";
      case "arrived":
        return "Driver has arrived, waiting out side";
      default:
        return "Invalid status";
    }
  }

  getStatusAnnounceMessage(status) {
    switch (status) {
      case "pending":
      case "offered":
      case "accepted":
        return "Contact trip coordinator for the ride activation";
      case "onway":
        return "Driver is on the way, Please stay  ready";
      case "arrived":
        return "Driver has arrived, waiting out side";
      default:
        return "Invalid status";
    }
  }

  getBorderColor(status) {
    switch (status) {
      case "pending":
      case "offered":
      case "accepted":
        return "border-gray-600";
      case "onway":
        return "border-indigo-600";
      case "arrived":
        return "border-green-600";
      default:
        return "border-red-600";
    }
  }

  getStatusColor(status) {
    switch (status) {
      case "pending":
      case "offered":
      case "accepted":
        return "bg-accepted";
      case "onway":
        return "bg-onway";
      case "arrived":
        return "bg-arrived";
      default:
        return "bg-accepted";
    }
  }

  onChangeLanguage(evt) {
    this.localStorageService.setItem('speaking-language', evt);
  }

  announceTrip(trip) {
    if (this.isMute) {
      const message = `Attention! ${trip.priorityClient.displayName}. ${this.getStatusAnnounceMessage(trip.jobStatus)}.`;
      this.announcer.enqueueSpeech(message, this.language);
    }
  }

  nameEncrytion(name: string) {
    const nameParts = name.split(' ');
    const firstName = nameParts[0];
    const lastName = nameParts[nameParts.length - 1];

    if (nameParts.length > 1) {
      const encryptedLastName = lastName.length > 2
        ? lastName.slice(0, 2) + lastName.slice(2).replace(/./g, '*')
        : lastName;
      return `${firstName} ${encryptedLastName}`;
    }

    return name; // If there's only one word, return it as it is.
  }

  getSpaceTypes() {
    this.operationService
      .getSpaceTypesWithToken({ status: 'active' })
      .subscribe(data => {
        if (data) {
          this.spaceTypeList = data;
          this.preSpaceTypes = data.reduce((obj, item) => (obj[item._id] = item, obj), {});
        }
      }, err => {
        sweetAlert("Error", err, "error", "Ok");
      });
  }

  logout() {
    this.operationService.removeToken();
    this.router.navigate(['/login']);
  }


  ngOnDestroy(): void {

  }




}
